
import { useMemo } from 'react';
import { ProjectData, RabEntry } from '../../../types';

export interface AnalysisResult {
  score: number;
  status: 'critical' | 'warning' | 'good';
  missingFields: string[];
  suggestions: string[];
}

export const useProjectAnalysis = (projectData: ProjectData, entries: RabEntry[]): AnalysisResult => {
  return useMemo(() => {
    let score = 0;
    const missingFields: string[] = [];
    const suggestions: string[] = [];

    // 1. Basic Data (30%)
    if (projectData.projectName) score += 10; else missingFields.push('Projektname');
    if (projectData.location) score += 5; else missingFields.push('Standort');
    if (projectData.builder) score += 5; else missingFields.push('Bauherr');
    if (projectData.companyName) score += 5; else suggestions.push('Ersteller-Info (Unternehmen)');
    if (projectData.companyLogo) score += 5; else suggestions.push('Firmenlogo für Deckblatt');

    // 2. Entries (50%)
    if (entries.length > 0) {
        score += 20;
        // Check diversity of categories
        const categories = new Set(entries.map(e => e.category));
        if (categories.size > 2) score += 15;
        else suggestions.push('Mehr Kategorien erfassen (z.B. Dach, Fassade)');
        
        // Check depth
        if (entries.length > 5) score += 15;
    } else {
        missingFields.push('Maßnahmenkatalog (leer)');
    }

    // 3. Images (20%)
    if (projectData.projectImage) score += 10; else suggestions.push('Titelbild für Deckblatt');
    if (projectData.appendixImages && projectData.appendixImages.length > 0) score += 10;
    else suggestions.push('Bilder für Risikoanalyse');

    let status: 'critical' | 'warning' | 'good' = 'good';
    if (score < 50) status = 'critical';
    else if (score < 80) status = 'warning';

    return { score: Math.min(100, score), status, missingFields, suggestions };
  }, [projectData, entries]);
};
